import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { MenuItem } from 'primeng/primeng';
import { AuthService } from '../../services/user/auth.service';
import { MenuService } from '../../services/utils/menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: 'menu.html'
})
export class MenuComponent implements OnInit {

  model: SideMenuItem[];
  testEnabled = false;

  // defines a default, hardcoded, application_id.
  defaultAppId = {
    loyalty: -1,
    admin: -2
  };

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private srvMenu: MenuService,
    private srvLocal: LocalStorageService
  ) {
/*
    var self = this;

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if(self.authService.user && self.authService.user.language && (self.authService.user.language != event.lang)){
        //console.log('LANG CHANGE MENU');
        self.authService.user.language = event.lang;
        self.loadMenu(false);
      }

    });
    */
    this.testEnabled = false;
  }

  loadMenu(useCache: boolean) {

    this.translate.get(
      [
        'menu.dashboard',
        'menu.administration',
        'menu.administrationUsers',
        'menu.administrationApplications',
        'menu.administrationCompanies',
        'menu.customerDb',
        'menu.customerDbList',
        'menu.customerBase',
        'menu.customerInfoSheet',
        'menu.campaingManager',
        'menu.campaingManagerSchedule',
        'menu.campaingManagerNew',
        'menu.shoppingHabits',
        'menu.administrationCurrencies',
        'menu.administrationLanguage',
        'menu.administrationToponym',
        'menu.administrationDivisions',
        'menu.administrationCountries',
        'menu.administrationStates',
        'menu.administrationProvinces',
        'menu.administrationDsnOperationMail',
        'menu.administrationBrands',
        'menu.administrationSalesNetworks',
        'menu.administrationServicetypes',
        'menu.administrationServices',
        'menu.administrationCertifications',
        'menu.administrationCalendars',
        'menu.campaingManagerList',
        'menu.administrationCalendarGroup'
      ]
    ).subscribe((res) => {

      console.log('MENU INIT', res);
      this.model = [
        {label: res['menu.dashboard'], icon: 'fa-home', application_id: 0, routerLink: ['/dashboard'], targetBlank: false}
      ];

      if (this.authService.user && !sessionStorage.getItem("menu")) {
        // check if user needs administration menu (based on its role)
        if (this.authService.user.role === 'S' || this.authService.user.role === 'A') {
          const authEntry = {
            id: '-1',
            ms_base_url: 'koncentro-auth',
            label: res['menu.administration'],
            icon: 'fa-cogs',
            items: [],
            application_id: this.defaultAppId.admin
          };

          this.model.push(authEntry);
          this.srvMenu.get(authEntry, useCache).subscribe((menu) => {
            this.model.find(el => el.application_id === authEntry.application_id).items = menu;
          });
        }

        this.authService.user.enabledUserApps.forEach((user_app) => {


          const entry = {
            id: user_app.id.toString(),
            ms_base_url: user_app.ms_base_url,
            label: user_app.application_description, icon: (user_app.app_icon) ? user_app.app_icon : 'fa-certificate',
            application_id: user_app.application_id,
            items: []
          };

          // fixme: qualcuno può commentare questo if? (ernesto)
          /*
          Ernesto on 09/10/2018, non vedo alcuna ragione per cui questo if debba esistere.
          non passa MAI all'interno di questo if, la cosa mi suona come un workaround non più utile.
          commento tutto, se si scassa quaalcosa scommento, altrimenti cancello.
          if (user_app.application_name === 'customerdb') {
            this.srvCustomers.getBaseUrl() = user_app.ms_base_url;
          }*/

          this.model.push(entry);
          this.srvMenu.get(entry, useCache, user_app.application_id).subscribe((menu) => {

            // adds submenu based on application_id (not ms_base_url!!!)
            this.model.find(el => el.application_id === entry.application_id).items = menu;
            sessionStorage.setItem("menu",JSON.stringify(this.model));
          });

        });
      } else
        this.model = JSON.parse(sessionStorage.getItem('menu'));
    });
  }

  ngOnInit() {
    this.loadMenu(false);
  }

  clearStoredFilters() {
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('Service') || key.includes('SourceFilters')) {
        sessionStorage.removeItem(key);
      }
    });
    if (sessionStorage.getItem('campaignId') && sessionStorage.getItem('campaignName')) {
      sessionStorage.removeItem('campaignId');
      sessionStorage.removeItem('campaignName');
    }
  }
}

/**
 * Site Menu Item.
 * @param id number
 * @param label string (required)
 * @param icon string (required)
 * @param application_id number (required) this identify parent menu (used to group them)
 * @param ms_base_url string
 * @param routerLink string[]
 * @param targetBlank boolean (true means open in a new tab ("T") type menu)
 * @param item MenuItem[] contains (eventually) child items
 */
export class SideMenuItem implements MenuItem {
  id?: string;
  label: string;
  icon: string;
  application_id: number;
  ms_base_url?: string;
  routerLink?: string[];
  items?: MenuItem[];
  targetBlank?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/views/menu/menu.component.ts